/**
 * Reactive media query of Bulma framework
 * Based on mixins from : 
 * https://github.com/jgthms/bulma/blob/master/sass/utilities/mixins.sass
 */

const tablet = 769
const desktop = 1024
const widescreen = 1216
const fullhd = 1408

export default {
  install(Vue) {
    Vue.prototype.$media = new Vue({
      data() {
        return {
          mobile: false,
          tablet: false,
          tabletOnly: false,
          touch: false,
          desktop: false,
          desktopOnly: false,
          untilWidescreen: false,
          widescreen: false,
          widescreenOnly: false,
          untilFullhd: false,
          fullhd: false
        }
      },
      methods: {
        updateMediaQuery() {
          this.mobile = window.matchMedia(`(max-width: ${tablet - 1}px)`).matches
          this.tablet = window.matchMedia(`(min-width: ${tablet}px)`).matches
          this.tabletOnly = window.matchMedia(`(min-width: ${tablet}px) and (max-width: ${desktop - 1}px)`).matches
          this.touch = window.matchMedia(`(max-width: ${desktop - 1}px)`).matches
          this.desktop = window.matchMedia(`(min-width: ${desktop}px)`).matches
          this.desktopOnly = window.matchMedia(`(min-width: ${desktop}px) and (max-width: ${widescreen - 1}px)`).matches
          this.untilWidescreen = window.matchMedia(`(max-width: ${widescreen - 1}px)`).matches
          this.widescreen = window.matchMedia(`(min-width: ${widescreen}px)`).matches
          this.widescreenOnly = window.matchMedia(`(min-width: ${widescreen}px) and (max-width: ${fullhd - 1}px)`).matches
          this.untilFullhd = window.matchMedia(`(max-width: ${fullhd - 1}px)`).matches
          this.fullhd = window.matchMedia(`(min-width: ${fullhd}px)`).matches
        },
        doPrint() {
          this.$nextTick(() => { window.print() })
        }
      },
      created() {
        window.addEventListener('resize', this.updateMediaQuery)
        this.updateMediaQuery();
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.updateMediaQuery)
      }
    })
  }
}
